import axios from 'axios'
import {validateFilesSize} from "../utils/fileSizeValidator";

export const api = axios.create({
  baseURL: '/api',
  withCredentials: true
})

export const uploadFiles = async (files: File[]) => {
  try {
    const errors = validateFilesSize(files);
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return undefined;
    }
    
    const response = await Promise.all(files.map(async file => {
      const formData = new FormData()
      formData.append('file', file)
      const { data } = await api.post('File', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })

      return data
    }))

    return response.map(res => ({
      id: res.fileId,
      fileName: res.fileName,
      fileUrl: res.filePath
    }))
  } catch(_) {
    return undefined
  }
}